<style lang="css" scoped>

.modal-mask {
    position: fixed;
    z-index: 9998;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, .5);
    transition: opacity .3s ease;
}

.modal-container {
    width: 800px;
    margin: 40px auto 0;
    padding: 20px 30px;
    background-color: #fff;
    border-radius: 2px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
    transition: all .3s ease;
    font-family: Helvetica, Arial, sans-serif;
}

.form-label > .form-control {
    margin-top: 0.5em;
}

.form-control {
    display: block;
    width: 100%;
    padding: 0.5em 1em;
    line-height: 1.5;
    border: 1px solid #ddd;
}

/*
 * The following styles are auto-applied to elements with
 * transition="modal" when their visibility is toggled
 * by Vue.js.
 *
 * You can easily play with the modal transition by editing
 * these styles.
 */

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}

.pppoe_sub_search {
    padding-left: 15px;
}

</style>

<template>
    <div name="modal" v-show="value">
        <div class="modal-mask" @click="cancel">
            <div class="modal-container" @click.stop>
                <v-data-table
                    :headers="headers"
                    :items="items"
                    :search="search"
                    :single-select=true
                    item-key="id"
                    sort-by="id"
                    class="elevation-1"
                    show-select
                    return-object
                    @dblclick:row="on_dbl_click"
                    v-model="selected_items"
                >
                    <template v-slot:top>
                        <v-toolbar flat>
                            <v-toolbar-title>Select PPPoE subscriber</v-toolbar-title>
                            <v-spacer></v-spacer>
                        </v-toolbar>
                        <div class="pppoe_sub_search">
                            <v-text-field
                                v-model="username"
                                label="Username">
                            </v-text-field>
                            <v-btn @click="lookup_with_name()">Lookup subscribers</v-btn>
                            <v-btn @click="show_all()">Show all subscribers</v-btn>
                        </div>
                        <v-toolbar flat>
                            <v-text-field
                                v-model="search"
                                append-icon="mdi-magnify"
                                label="Filter"
                                single-line
                                hide-details
                            ></v-text-field>
                        </v-toolbar>
                    </template>
                    <template v-slot:no-data>
                    </template>
                </v-data-table>
            
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="cancel">Cancel</v-btn>
                <v-btn color="blue darken-1" text @click="select">Select</v-btn>
            </div>
        </div>
    </div>
</template>
  
<script>

import api_client from '../services/api.js';

export default {
    name: 'pppoe_sub_box',
    data: () => ({
        username: '',

        selected_items: [],
        search: '',
        items: [],
        headers: [
            { text: 'Id', value: 'id', align: 'start' },
            { text: 'Username', value: 'username' },
            { text: 'MAC', value: 'mac' },
            { text: 'Port', value: 'port_id' },
            { text: 'SVID', value: 'svid' },
            { text: 'CVID', value: 'cvid' },
            { text: 'IP', value: 'peer_ip_addr' },
            { text: 'MTU', value: 'mtu' },
            { text: 'Ingress Qdisc', value: 'ingress_shaper' },
            { text: 'Egress Qdisc', value: 'egress_shaper' },
            { text: 'RX pkts', value: 'rxp' },
            { text: 'TX pkts', value: 'txp' },
            { text: 'RX bytes', value: 'rxb' },
            { text: 'TX bytes', value: 'txb' },
            { text: 'Uptime', value: 'uptime', width: '300px' },
        ],
    }),

    created() {
    },

    props: {
        value: {
            required: true
        }
    },
    methods: {
        show_all() {
            api_client.run_get_query('/pppoe/ipv4_subsc')
                .then(response => {
                    if (response.data.hasOwnProperty("err_msg")) {
                        this.$fire({title: "Command failed", text: response.data.err_msg, type: "warning"});
                    }
                    else {
                        this.items = response.data;
                    }
                })
                .catch(error => {
                    console.log(error)
                })
        },

        lookup_with_name() {
            if (this.username != '') {
                let data = {
                    username: this.username
                };

                api_client.run_post_query('/pppoe/ipv4_subsc_with_username', data)
                .then(response => {
                    if (response.data.hasOwnProperty("err_msg")) {
                        this.$fire({title: "Command failed", text: response.data.err_msg, type: "warning"});
                    }
                    else {
                        this.items = [response.data];
                    }
                })
                .catch(error => {
                    console.log(error)
                })
            }
        },

        on_dbl_click(event, data) {
		    this.$emit("selected", 
                    { 
                      id: data.item.id,
                      username: data.item.username
                    }
            );
        },

        select() {
            if (typeof this.selected_items[0] != "undefined") {
                this.$emit("selected",
                    { 
                      id: this.selected_items[0].id, 
                      username: this.selected_items[0].username
                    });
            }
        },

        cancel() {
            this.$emit("canceled");
        },
    }
};
</script>
